<template>
  <vs-popup :active="opened" fullscreen title="Preview" class-content="content-full" @close="$emit('close')">
    <iframe ref="preview_iframe"
            frameborder="0"
            style="width: 100%; height: 100%;"></iframe>
  </vs-popup>
</template>

<script>

export default {
  name: 'assign-by-email-preview',
  props: {
    html: String,
    opened: Boolean
  },
  watch: {
    html: {
      handler (value) {
        if (value) {
          this.$refs.preview_iframe.srcdoc = value;
        } else {
          this.$refs.preview_iframe.srcdoc = null;
        }
      }
    }
  },
  mounted () {
    if (this.html && this.$refs.preview_iframe.srcdoc) {
      this.$refs.preview_iframe.srcdoc = this.html;
    }
  }
};
</script>


<style scoped>

</style>
